/* eslint-disable no-param-reassign */
import qs from 'qs';
import { useUserStore } from '@/store';
import { useGlobSetting } from '@/config';
import { isAlipayBrowser } from '@/utils';

type CustomRequestOptions = {
  /* GET 请求的query参数，使用qs重新格式化 */
  query: Recordable;
  /* 是否需要携带Token授权，显式定义为 false 时不需要授权 */
  auth: boolean;
  /** 是否展示toast提示，显式定义为 false 时不展示 */
  toast: boolean;
  /* 是否返回原生响应 */
  returnNativeResponse: boolean;
  /** 是否需要转换返回结果 */
  isTransformResponse: boolean;
};

export type RequestOptions = UniApp.RequestOptions & IUniUploadFileOptions & Partial<CustomRequestOptions>; // 添加uni.uploadFile参数类型

// 请求基准地址
const { baseUrl, urlPrefix, tokenKey, tokenPrefix } = useGlobSetting();

// 拦截器配置
const httpInterceptor = {
  // 拦截前触发
  invoke(options: RequestOptions) {
    // 接口请求支持通过 query 参数配置 queryString
    if (options.query) {
      const queryStr = qs.stringify(options.query);
      if (options.url.includes('?')) {
        options.url += `&${queryStr}`;
      } else {
        options.url += `?${queryStr}`;
      }
    }

    // 非 http 开头需拼接地址
    if (!options.url.startsWith('http')) {
      options.url = baseUrl + urlPrefix + options.url;
    }

    // 1. 请求超时
    options.timeout = 10000; // 10s

    // 2. （可选）添加小程序端请求头标识
    options.header = {
      // platform, // 可选，与 uniapp 定义的平台一致，告诉后台来源
      // #ifdef MP-WEIXIN
      'X-Requested-From': 'mp_weixin', // 告诉服务端是微信小程序发起的请求
      // #endif

      // #ifdef MP-ALIPAY
      // @ts-ignore
      'X-Requested-From': 'mp_alipay', // 告诉服务端是微信小程序发起的请求
      // #endif

      // #ifdef H5
      // @ts-ignore
      'X-Requested-From': isAlipayBrowser() ? 'mp_h5' : 'alipay_h5', // 告诉服务端是微信小程序发起的请求
      // #endif

      ...options.header,
    };

    // 3. 添加 Token 请求头标识
    const userStore = useUserStore();
    if (options.auth !== false) {
      options.header[tokenKey] = `${tokenPrefix} ${userStore.token}`.trim();
    }
  },
};

export const requestInterceptor = {
  install() {
    // 拦截 request 请求
    uni.addInterceptor('request', httpInterceptor);
    // 拦截 uploadFile 文件上传
    uni.addInterceptor('uploadFile', httpInterceptor);
  },
};
